import React, {useState} from 'react';
import { useForm } from 'react-hook-form';
import ReCAPTCHA from "react-google-recaptcha";
import CONFIG from '../_config.js';
import '../styles/_form.scss';

const GetQuote = (props) => {  
    document.body.classList = "get-quote whiteBg";
    const { register, handleSubmit, errors } = useForm();
    const [isValid, setValid] = useState(false);

    //If coming from any services page, get the service category & it's sub category options
    var query = props.location.search.replace('?', '').split('&');
    var serviceCat = decodeURIComponent(query[0]).replace('s=', '');
    var defaultService = decodeURIComponent(query[1]).replace('sc=', '');
    
    const services = require('../jsons/quote-service-options').default;
    var serviceList = services.generic;
    if(services[serviceCat]) {
        serviceList = serviceList.concat(services[serviceCat]); 
    }
    
    const onChangeHandler = (e) => {
        var _target = e.target;
        var _targetFieldset = _target.parentNode;
        _target.value !== '' ? _targetFieldset.classList.add('text-in') : _targetFieldset.classList.remove('text-in');               
    }    
    function onChange(value) {            
        if(value){
            setValid(true);
        }else{
            alert("Error Verifying reCAPTCHA, please try again.");
        }   
    }
    const onSubmit = data => {
        if(isValid){
            fetch(CONFIG.getQuote, {
                method: 'POST',
                body: JSON.stringify(data),
            }).then(() => alert("Successful"))
            .catch(() => alert("There was an error, please try again"));
        }else{
            alert("Please Verify reCAPTCHA.");
        }       
    };
    return(
        <div className="innerWrapper">
            <div className="innerBox">
                <div className="formHeader">
                    <h3>Let’s get started!</h3>
                    <p>GET A BALLPARK COSTING ON THE PRODUCT.</p>
                </div>                
                <form onSubmit={handleSubmit(onSubmit)}>
                    <fieldset className={errors.fname && "error"}>  
                        <label htmlFor="name">Name *</label>
                        <input type="text" id="name" name="fname" ref={register({ required: true })} onChange={onChangeHandler}/>
                        <span></span>    
                        {errors.fname && <p>This field is required.</p> }                                             
                    </fieldset>
                    <fieldset className={errors.company && "error"}>
                        <label htmlFor="company">Company *</label>
                        <input type="text" id="company" name="company" ref={register({ required: true})} onChange={onChangeHandler} />
                        <span></span>
                        {errors.company && <p>This field is required.</p> } 
                    </fieldset>
                    <fieldset className={errors.email && "error"}>
                        <label htmlFor="email">Email *</label>
                        <input type="text" id="email" name="email" ref={register({ required: true, pattern: /^\S+@\S+$/i})} onChange={onChangeHandler} />
                        <span></span>
                        {errors.email && errors.email.type === "required" &&  <p role="alert">This field is required.</p> }
                        {errors.email && errors.email.type === "pattern" &&  <p role="alert">Please enter a valid email address</p> }
                    </fieldset>
                    <fieldset className={errors.ref && "error"}>
                        <select name="ref" ref={register({ required: true })} defaultValue={defaultService}>
                            <option value="">What you are looking for?</option>
                            {serviceList.map((d,i) => 
                                <option key={i} value={d}>{d}</option>
                            )}
                        </select>
                        <span></span>
                        {errors.ref && <p>This field is required.</p> } 
                    </fieldset>
                    <fieldset className={errors.projectbudget && "error"}>
                        <select name="projectbudget" ref={register({ required: true })}>
                            <option value="">Project Budget*</option>
                            <option value="$1K - $5K">$1K - $5K</option>
                            <option value="$5K - $20K">$5K - $20K</option>
                            <option value="$20K - $50K">$20K - $50K</option>
                            <option value="$50K - $100K">$50K - $100K</option>
                            <option value="$100K - $200K">$100K - $200K</option>
                            <option value="$200K - $500K">$200K - $500K</option>
                            <option value="$500K and above">$500K and above</option>                        
                        </select>
                        <span></span>
                        {errors.projectbudget && <p>This field is required.</p> } 
                    </fieldset>
                    <fieldset className={errors.phone && "error"}>
                        <label htmlFor="phonenumber">Phone number</label>
                        <input type="tel" id="phonenumber" name="phone" ref={register({required: true, minLength: 10})} onChange={onChangeHandler} />
                        <span></span>
                        {errors.phone && errors.phone.type === "required" &&  <p role="alert">This field is required.</p> }
                        {errors.phone && errors.phone.type === "minLength" &&  <p role="alert">Minlength for the field is 10 characters</p> }
                    </fieldset>
                    <fieldset className={errors.description && "error"}>
                        <label htmlFor="description">Description</label>
                        <input type="text" id="description" name="description" ref={register} onChange={onChangeHandler} />
                        <span></span>
                        {errors.description && <p>This field is required.</p> } 
                    </fieldset> 
                    <fieldset className="s-full">
                        <ReCAPTCHA
                            sitekey={CONFIG.recaptchaSiteKey}
                            onChange={onChange}
                        />
                        <br/>
                        <input type="submit" className="btn pill quote grad-orange " value="GET A QUOTE" />
                    </fieldset>
                </form>
            </div>            
        </div>
    )
}

export default GetQuote;